import * as React from 'react';

export interface IValidationResult {
	key: string;
	tab?: string;
	result: {
		valid: boolean;
		validated: boolean;
		present?: boolean;
		min?: boolean;
		max?: boolean;
		desc?: string;
	};
}

interface IValidationProps {
	onChange?: (e: React.ChangeEvent) => any;
	name?: string;
	valname?: string;
	validation: IValidationResult[];
	hideValidationUntilChanged?: boolean;
	hideValidationUntilBlurred?: boolean;
}

interface IValidationState {
	liveValidate: boolean;
}

const getValidationDesc = (validationResult: IValidationResult) => {
	return validationResult.result.desc || 'Unknown Error';
};

const getValidationResult = (validation: IValidationResult[], props: IValidationProps) => {
	return (validation || []).find((valResult) => (props.valname || props.name || '') === valResult.key);
};

const isValid = (validationResult: IValidationResult) => {
	return validationResult ? validationResult.result.valid : false;
};

export const withValidation = <T extends object>(WrappedComponent: React.ComponentType<T>) => {
	const Wrapped: React.FC<T & IValidationProps> = (props) => {
		const [state, setState] = React.useState<IValidationState>({
			liveValidate: !(props.hideValidationUntilBlurred || props.hideValidationUntilChanged)
		});

		const { hideValidationUntilBlurred, hideValidationUntilChanged, validation, onChange, ...otherProps } = props;
		const { liveValidate } = state;

		const validationResult = getValidationResult(validation, props);
		const valid = validationResult ? isValid(validationResult) : true;
		const displayValid = liveValidate ? valid : true;

		return <React.Fragment>
			<WrappedComponent
				{...otherProps as T}
				is-valid={displayValid.toString()}
				onChange={(e: React.ChangeEvent) => {
					setState({
						liveValidate: hideValidationUntilChanged ? true : liveValidate
					});

					if (onChange) {
						onChange(e);
					}
				}}
				onBlur={(e: React.FocusEvent) => {
					setState({
						liveValidate: hideValidationUntilBlurred ? true : liveValidate
					});
				}}
			/>
			{validationResult && !displayValid && <label className="form__label--error">{getValidationDesc(validationResult)}</label>}
		</React.Fragment>;

	};

	return Wrapped;
};
